import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import Constants from "../../../util/Constants";
import DailySalesReportAPI from "../../../api/DailySalesReportAPI";
import ApiUiController from "../../../controller/ApiUiController";
import { CSVLink } from "react-csv";
import { Button, Table } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import StackedChartComponent from "../chartComponent/MultiBarChart";
import FilterPannel from "../../filter/FilterPannel"
import moment from 'moment'



class BookingBySourceByProject extends React.Component {
  constructor(props) {
    super(props);
    const model = reactLocalStorage.getObject(Constants.Model)
    const sourceOptions = model.source.options || [];
    const projectOptions = model.project.options || [];
    this.fields = model.sales_order.fields;
    this.loggedInUserId = reactLocalStorage.getObject(Constants.LoggedInUser).user_id;
    this.state = {
      progressData: [],
      sourceOptions,
      projectOptions,
      filters: [{
        field: "responsible_person",
        condition: "in",        
        value: `~${this.loggedInUserId}~`,
      },{
        field: "start_date",
        condition: "in",
        value: `${moment().startOf("month").format("YYYY-MM-DD HH:mm:ss")}~${moment().endOf("month").format("YYYY-MM-DD HH:mm:ss")}`,
      },],
      tableData:[],
      series: [],
      inApiCall: false,
      isFilterOpen: true,
      exportData: [],
    };
  }

  componentDidMount(l) {
    this.fetchApi(this.state.filters,this.onSuccess, this.onFail);
  }


 fetchApi = (filters,onSuccess, onFail) => {
    const body = {
      filters : filters,
      model: "sales_order_model",
      x:"source",
      y:"project",
      z:"COUNT(so.id)"
    }
    this.setState({inApiCall: true})
    DailySalesReportAPI.getFixedReport(body, onSuccess, onFail);
  };



  parseData=(response )=>{
    //    Prepare table data
    const tableData = this.state.sourceOptions.map((source) => {
      const row = { source: source.label };
      this.state.projectOptions.forEach((project) => {
        // Calculate the total sum for each responsible project per source
        const totalSum = response
          .filter(
            (item) =>
              {
                return item.source === source.value &&
                item.project === project.value  
          })
          .reduce((sum, item) => sum + (item.sum || 0), 0);
  
        row[project.label] = totalSum;
      });
      return row;
    });
  
    // Prepare chart series
    const series = this.state.projectOptions.map((project) => ({
      name: project.label,
      data: this.state.sourceOptions.map((source) => {
        // Calculate the total sum for each responsible project per source
        const totalSum = response
          .filter(
            (item) =>
              {
                return item.source=== source.value &&
             item.project === project.value
          })
          .reduce((sum, item) => sum + (item.sum || 0), 0);
  
        return totalSum;
      }),
    }));
return { tableData, series };

}

  onSuccess =(data)=>{
    const {tableData , series} = this.parseData(data);
    const exportData = tableData;
    this.setState({ tableData,series ,exportData, inApiCall: false  });  
  }

  onFail = (err) =>{
    console.log("Failed to fetch data" , err);
  }

  toggleFilter = () => {
    this.setState((prevState) => ({
      isFilterOpen: !prevState.isFilterOpen,
    }));
  };

  onFilterChange = (updatedFilters) => {
    this.setState({ filters: updatedFilters },    
     this.fetchApi(this.state.filters,this.onSuccess, this.onFail));
  };

   
    

render(){
const {exportData , filters ,isFilterOpen , inApiCall , projectOptions , tableData , series  } = this.state;
  const table = (<Table bordered hover>
    <thead>
      <tr>
        <th></th>
        {projectOptions.map((person, index) => (
          <th key={index}>{person.label}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {tableData.map((row, index) => (
        <tr key={index}>
          <td>{row.source}</td>
          {projectOptions.map((person, idx) => (
            <td key={idx}>{row[person.label]}</td>
          ))}
        </tr>
      ))}
    </tbody>
  </Table>);;

return (
      <ApiUiController inApiCall={inApiCall}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-6">
                <h1>Booking By Source By Person</h1>
              </div>
              <div className="col-md-6">
                <CSVLink
                 data={exportData} filename={`booking_by_source_by_project_report.csv`}>
                  <Button className="buttons btn-success">Export</Button>
                </CSVLink>
              </div>
            </div>
          </div>
          <div className="col-md-4 pt-1">
            <div className="row filterrow">
              <div className="col-md-12 lastcol">
                <div className="m-right">
                  <div className="btn btn-lead btn-sm filter-button" onClick={this.toggleFilter}>
                    <FaFilter />
                    <span className="badge badge-danger badge-mini rounded-circle">
                      {this.state.filters.length}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row pt-3">
          <div className="container-fluid">
            <div className="row">
              <div className={`col-md-${isFilterOpen ? 9 : 12}`}>
              <StackedChartComponent progressOptions={projectOptions} progressSums={series} type={"multiBar"} />
              <div className="col-md-12">{table}</div>
              </div>
              {this.state.isFilterOpen && (
                <FilterPannel
                  filters={filters}
                  fields={this.fields}
                  onFilterChange={this.onFilterChange}
                  isFilterOpen={isFilterOpen}
                  restrict={false}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </ApiUiController>)


}
}


export default BookingBySourceByProject;

